// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Users_establishments__2My2c","header":"Users_header__2zlWH","tableHeader":"Users_tableHeader__2PC8y"};